import React from 'react';
import './about.styles.scss';

const About = () => {
  return (
    <div className="about-container">
      <section className="about-hero">
        <div className="container">
          <h1>About Rmt-DBA</h1>
          <p className="white-subtitle">Delivering enterprise-grade IT solutions with unparalleled expertise and innovation</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="content-grid">
            <div className="about-text">
              <h2>Excellence in Technology Solutions</h2>
              <p>
                Rmt-DBA stands at the forefront of remote database administration services, providing comprehensive 
                solutions that drive database performance, security, and reliability for businesses 
                and growing organizations worldwide.
              </p>
              <p>
                With deep expertise spanning database management, cloud infrastructure, and network architecture, 
                our team delivers cutting-edge solutions that scale with your business needs while maintaining 
                the highest standards of security, performance, and reliability.
              </p>
            </div>
            
            <div className="stats-grid">
              <div className="stat-item">
                <h3>500+</h3>
                <p>Projects Delivered</p>
              </div>
              <div className="stat-item">
                <h3>15+</h3>
                <p>Years Experience</p>
              </div>
              <div className="stat-item">
                <h3>50+</h3>
                <p>Enterprise Clients</p>
              </div>
              <div className="stat-item">
                <h3>99.9%</h3>
                <p>Uptime Guarantee</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mission-vision">
        <div className="container">
          <div className="mission-grid">
            <div className="mission-item">
              <h2>Our Mission</h2>
              <p>
                To empower organizations with innovative technology solutions that drive efficiency, 
                security, and growth. We are committed to delivering exceptional service through 
                expertise, reliability, and strategic partnership with our clients.
              </p>
            </div>
            <div className="mission-item">
              <h2>Our Vision</h2>
              <p>
                To be the leading provider of enterprise IT solutions, recognized for our technical 
                excellence, innovative approach, and unwavering commitment to client success in the 
                digital transformation era.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <h2>Our Expertise</h2>
          <p className="section-subtitle">
            Backed by certified professionals and industry-leading methodologies
          </p>
          
          <div className="expertise-grid">
            <div className="expertise-card">
              <div className="expertise-icon">�️</div>
              <h3>Database Excellence</h3>
              <p>
                Advanced database architecture, optimization, and management across all major platforms. 
                From Oracle to MongoDB, we ensure your data infrastructure performs at peak efficiency.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
